import { Injectable } from "@angular/core";

@Injectable()
export class WsDialogInjectable {
  inputs!: { [key: string]: any };
  closeClicked!: (data?: any) => void;

  getData?: () => any;
}

/**
 * Base class that must be extended by all components meant to be used inside WsDialog.
 * Properties:
 * - inputs: The inputs object passed to WsDialog inside the data object.
 * - close: A function that closes WsDialog.
 */
export class WsDialogContentBase {
  inputs: { [key: string]: any };
  close: (data?: any) => void;

  constructor(
    injector: WsDialogInjectable,
  ) {
    this.inputs = injector.inputs;
    this.close = injector.closeClicked;
  }
}